import PropTypes from 'prop-types';
//material-ui
import { styled } from '@mui/material/styles';

// third-party
import { SnackbarProvider } from 'notistack';

// project imports
import Loader from 'components/Loader';
import { useGetSnackbar } from 'api/snackbar';

// assets
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '& .notistack-MuiContent': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: '50px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
    padding: '6px 16px 6px 8px',
    border: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    minWidth: '340px',
    maxWidth: '450px'
  },
  '& .notistack-MuiContent-success': {
    borderLeft: `5px solid ${theme.palette.success.main}`
  },
  '& .notistack-MuiContent-error': {
    borderLeft: `5px solid ${theme.palette.error.main}`
  },
  '& .notistack-MuiContent-info': {
    borderLeft: `5px solid ${theme.palette.info.main}`
  },
  '& .notistack-MuiContent-warning': {
    borderLeft: `5px solid ${theme.palette.warning.main}`
  },
  '& .SnackbarItem-message': {
    padding: '8px 0',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px'
  },
  '& .SnackbarItem-action': {
    paddingLeft: 4,
    marginRight: -4
  }
}));

const IconWrapper = styled('div')(({ theme, color }) => ({
  width: 44,
  height: 44,
  flexShrink: 0,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
  backgroundColor: theme.palette[color].lighter,
  color: theme.palette[color].main,
  '& svg': {
    fontSize: '24px'
  }
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }) {
  const { snackbar } = useGetSnackbar();
  const iconSX = { marginRight: 8, fontSize: '1.15rem' };

  if (!snackbar) return <Loader />;

  return (
    <StyledSnackbarProvider
      maxSnack={snackbar.maxStack}
      dense={snackbar.dense}
      iconVariant={{
        success: (
          <IconWrapper color="success">
            <CheckCircleOutlined />
          </IconWrapper>
        ),
        error: (
          <IconWrapper color="error">
            <CloseCircleOutlined />
          </IconWrapper>
        ),
        warning: (
          <IconWrapper color="warning">
            <WarningOutlined />
          </IconWrapper>
        ),
        info: (
          <IconWrapper color="info">
            <InfoCircleOutlined />
          </IconWrapper>
        )
      }}
      hideIconVariant={false}
    >
      {children}
    </StyledSnackbarProvider>
  );
}

Notistack.propTypes = { children: PropTypes.any };
